export const createAction = (type, payload) => ({ type, payload });
// This means we don't have to type the key names of this object when writing dispatches
